import styled from 'styled-components';
var FormGroup = styled.div.withConfig({
  displayName: "FormGroup",
  componentId: "sc-5yb9kh-0"
})(["margin-bottom:0.9375rem;position:relative;"]);
export default FormGroup;